export default __webpack_public_path__ + "locales/bg/EmbeddingPanel.json?hash=d3af3764f2fc45b6c60155c51c41adeb";